export { default } from "ember-stereo/helpers/current-sound";
